export default "__VITE_ASSET__DF3FB6iQ__"